import React from "react";
import { labels } from "../../../../../localization/labels";
import EntityMessageLogTypeService from "../../../../../services/EntityMessageLogTypeService";
import { constants } from "../../../../../utils/Constants";
import {
  messageLogTypeValidationRules as validationRules,
  validateEntity
} from "../../../../../validators/validationRules";
import TableUtils from "../../../../core/Table/TableUtils";
import TableComponentWithDialog from "../../../page/TableComponentWithDialog";
import MessageLogType from "./MessageLogType";

class MessageLogTypeContainer extends TableComponentWithDialog {
  constructor(props) {
    super(props);

    this.props = props;
    this.entityMessageLogTypeService = new EntityMessageLogTypeService();
  }

  resetEntity = () => {
    return {
      name: null
    };
  };

  columns = this.initColumns([
    {
      dataField: "id",
      text: labels.id,
      sort: true,
      classes: "column-id",
      headerClasses: "column-header-id"
    },
    {
      dataField: "name",
      text: labels.name,
      sort: true,
      headerClasses: "column-header",
      formatter: TableUtils.textFormatter
    },
    {
      dataField: "description",
      text: labels.description,
      sort: true,
      headerClasses: "column-header",
      formatter: TableUtils.textFormatter
    }
  ]);

  handleDialogChange = event => {
    const { newEntity } = this.state;
    newEntity[event.target.id] = event.target.value;
    const disabled = !this.validator(newEntity);
    this.setState({ newEntity, disabled });
  };

  loadData = pageInfo => {
    this.prepareCall(
      this.entityMessageLogTypeService.getEntities(
        pageInfo,
        this.sortInfo,
        this.onDataLoad,
        this.messageHandler.handleError
      )
    );
    this.performCalls();
  };

  getComponentTitle = () => {
    return undefined;
  };

  onCreateData = type => {
    this.prepareCall(
      this.entityMessageLogTypeService.postEntity(
        type,
        this.onDataSaveResponse,
        this.messageHandler.handleError
      )
    );
    this.performCalls();
  };

  updateData = type => {
    this.prepareCall(
      this.entityMessageLogTypeService.putEntity(
        type,
        this.onDataSaveResponse,
        this.messageHandler.handleError
      )
    );
    this.performCalls();
  };

  onDeleteData = type => {
    this.prepareCall(
      this.entityMessageLogTypeService.deleteEntity(
        type,
        this.onDataDeleteResponse,
        this.onDeleteSuccessMessage,
        this.messageHandler.handleError
      )
    );
    this.performCalls();
  };

  validator = entity => {
    return validateEntity(entity, validationRules.generalData);
  };

  getNonSelectableRows = () => {
    return [constants.MESSAGE_LOG_TYPE_PROTECTED_INITIAL];
  };

  loadSelectedData = url => {
    this.prepareCall(
      this.entityMessageLogTypeService.getEntitiesByUrl(
        url,
        this.onEntityLoad,
        this.messageHandler
      )
    );
    this.performCalls();
  };

  onEntityLoad = data => {
    if (data.id === constants.MESSAGE_LOG_TYPE_PROTECTED_INITIAL) {
      data.noDateRange = true;
    }
    this.onSelectedEntityLoad(data);
  };

  render() {
    const maxLength = {
      name: 255,
      description: 2000
    };

    return (
      <MessageLogType
        {...this.renderProps()}
        cellEditProps={this.cellEditProps}
        maxLength={maxLength}
        disabled={this.state.disabled}
        validationRules={validationRules.generalData}
      />
    );
  }
}

export default MessageLogTypeContainer;
